import createClient from "openapi-fetch";

import { SEARCH_ENDPOINT } from "@/config";
import type { paths } from "@/features/search/api/schema";

/**
 * Typed REST client for the whoppah-search microservice.
 *
 * Types come from `./schema.d.ts`, generated from the service's OpenAPI spec
 * via `yarn search-codegen`. openapi-fetch serializes array query params as
 * repeated keys (`?category=a&category=b`), which is what the service expects.
 */
export const searchClient = createClient<paths>({ baseUrl: SEARCH_ENDPOINT });
